import { WalletProviderEnum } from '@dynamic-labs/sdk-api-core';

import type { DynamicClient } from '../../../client/types';
import { getChainFromVerifiedCredentialChain } from '../../../utils/getChainFromVerifiedCredentialChain';
import type { Chain } from '../../chain';
import { DYNAMIC_WAAS_METADATA } from '../constants';

type GetAllUserWaasAddressesForChainParams = {
  chain: Chain;
};

export const getAllUserWaasAddressesForChain = (
  { chain }: GetAllUserWaasAddressesForChainParams,
  client: DynamicClient
): string[] => {
  if (!client.user) {
    return [];
  }

  const waasWalletCredentials =
    client.user.verifiedCredentials.filter(
      (credential) =>
        credential.walletProvider === WalletProviderEnum.EmbeddedWallet &&
        credential.walletName
          ?.toLowerCase()
          .startsWith(DYNAMIC_WAAS_METADATA.normalizedWalletName) &&
        credential.address &&
        credential.chain &&
        getChainFromVerifiedCredentialChain(credential.chain) === chain
    ) ?? [];

  const waasAddresses: string[] = waasWalletCredentials.map(
    // casting because we're already filtering out credentials without an address
    (credential) => credential.address as string
  );

  return waasAddresses;
};
